module.exports = __webpack_public_path__ + "static/media/blueTick.30c8c924.svg";